<template>
    <b-form @submit.stop.prevent="submitPost">

        <div class="d-none">
            <b-form-group
                :label="trans('community.post_title')"
                label-for="title"
            >
                <b-form-textarea
                        id="title"
                        v-model="formData.title"
                        :placeholder="trans('example_post_title')"
                        rows="2"
                        max-rows="6"
                        required
                ></b-form-textarea>
            </b-form-group>
        </div>

        <label class="pb-2">{{formData.title}}</label>

        <b-form-group
                :label="!hasTitle ? trans('community.post_description') : ''"
                label-for="title"
        >
            <b-form-textarea
                    id="description"
                    v-model="formData.description"
                    :placeholder="trans('community.post_description')"
                    rows="3"
                    max-rows="6"
                    v-bind:required="hasTitle"
            ></b-form-textarea>

            <b-form-input
                name="is_room_post"
                id="is_room_post"
                value="1"
                class="d-none"
            />
        </b-form-group>

        <b-form-group>
            <b-form-radio-group
                    id="radio-group-1"
                    v-model="formData.color_bkg_title"
                    name="radio-options"
                    buttons
                    button-variant="danger"
            >
                <template v-for="option in options">
                    <gradient-option :option="option" :key="option.value"/>
                </template>
            </b-form-radio-group>
        </b-form-group>

        <div class="d-flex justify-content-end">
            <b-button type="submit" variant="secondary" ref="postButton" v-bind:class="this.loading ? 'disabled' : ''">{{trans('community.publish')}}</b-button>
        </div>
    </b-form>
</template>

<script>
    import GradientOption from "./GradientOption";

    export default {
        name: "PostForm",
        props:{
            callback: Function,
            postData: Object,
            title: String,
            loading: Boolean
        },
        components:{GradientOption},
        mounted() {
            this.edit = false;

            this.formData.title = this.hasTitle ? this.title : '';

            if(this.postData.hasOwnProperty('title')){
                this.formData.title = this.hasTitle ? this.postData.title : this.title;
                this.formData.description = this.postData.description;
                this.formData.color_bkg_title = this.postData.color_bkg_title;
                this.formData.private = this.postData.private;
                this.formData.id = this.postData.id;
                this.formData.is_room_post = this.postData.is_room_post;
                this.edit = true;
            }
        },
        data(){
            return {
                formData: {
                    title: '',
                    description: '',
                    color_bkg_title: '1',
                    private: 0,
                    id: null,
                    is_room_post: 1,
                },
                options: [
                    { text: 'color-1', value: '1' },
                    { text: 'color-2', value: '2' },
                    { text: 'color-3', value: '3' },
                    { text: 'color-4', value: '4' },
                    { text: 'color-5', value: '5' },
                    { text: 'color-6', value: '6' },
                    { text: 'color-7', value: '7' },
                ],
                edit: false
            }
        },
        methods:{
            submitPost(){
                const event = this.edit ? 'onEditPost' : 'onCreatePost';
                this.$emit(event, this.formData);
            }
        },
        computed:{
            hasTitle: function(){
                return this.title !== '';
            }
        }
    }
</script>
